import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sremote-support1',
  templateUrl: './sremote-support1.component.html',
  styleUrls: ['./sremote-support1.component.scss']
})
export class SremoteSupport1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
